// extracted by mini-css-extract-plugin
export default {"education":"Education_education__zZ1Zy"};